import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useHistory } from 'react-router-dom';
import UIFlex from 'UIComponents/layout/UIFlex';
const DropdownContext = /*#__PURE__*/createContext(null);
export const useDropdownState = () => {
  const state = useContext(DropdownContext);
  if (!state) throw new Error('Cannot access DropdownState without provider parent');
  return state;
};
export const Dropdown = ({
  children
}) => {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [drilldownKey, setDrilldownKey] = useState(null);
  const toggle = useCallback(() => {
    setShow(isShowing => !isShowing);
  }, []);
  const state = useMemo(() => ({
    show,
    toggle,
    drilldownKey,
    setDrilldownKey
  }), [drilldownKey, show, toggle]);
  useEffect(() => {
    return history.listen(() => {
      setShow(false);
      setDrilldownKey(null);
    });
  }, [history, setShow]);
  return /*#__PURE__*/_jsx(DropdownContext.Provider, {
    value: state,
    children: children
  });
};
export const DropdownButton = (_ref) => {
  let {
    children,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "onClick"]);

  const {
    toggle
  } = useDropdownState();
  const handleClick = useCallback(e => {
    toggle();

    if (onClick) {
      onClick(e);
    }
  }, [onClick, toggle]);
  return /*#__PURE__*/_jsxs(UIButton, Object.assign({
    use: "unstyled"
  }, props, {
    onClick: handleClick,
    children: [children, /*#__PURE__*/_jsx(UIIcon, {
      className: "m-left-1",
      name: "down",
      size: 12
    })]
  }));
};
export const DropdownButtonItem = (_ref2) => {
  let {
    onClick
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, ["onClick"]);

  const {
    toggle
  } = useDropdownState();
  const handleClick = useCallback(e => {
    toggle();

    if (onClick) {
      onClick(e);
    }
  }, [onClick, toggle]);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    use: "unstyled"
  }, props, {
    onClick: handleClick
  }));
};
export const DropdownLinkItem = (_ref3) => {
  let props = Object.assign({}, _ref3);
  return /*#__PURE__*/_jsx(UIRouterButton, Object.assign({}, props, {
    onClick: props.onClick,
    use: "unstyled"
  }));
};
export const DropdownDrilldownButton = (_ref4) => {
  let {
    onClick,
    drilldownKey,
    children
  } = _ref4,
      props = _objectWithoutPropertiesLoose(_ref4, ["onClick", "drilldownKey", "children"]);

  const {
    setDrilldownKey
  } = useDropdownState();
  const handleClick = useCallback(e => {
    setDrilldownKey(drilldownKey);

    if (onClick) {
      onClick(e);
    }
  }, [drilldownKey, onClick, setDrilldownKey]);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    use: "unstyled"
  }, props, {
    onClick: handleClick,
    children: /*#__PURE__*/_jsxs(UIFlex //@ts-expect-error as isn't exposed in the types but is needed here
    , {
      as: "span",
      justify: "between",
      children: [children, /*#__PURE__*/_jsx(UIIcon, {
        name: "right"
      })]
    })
  }));
};
export const DropdownResetDrilldownButton = (_ref5) => {
  let {
    onClick,
    children
  } = _ref5,
      props = _objectWithoutPropertiesLoose(_ref5, ["onClick", "children"]);

  const {
    setDrilldownKey
  } = useDropdownState();
  const handleClick = useCallback(e => {
    setDrilldownKey(null);

    if (onClick) {
      onClick(e);
    }
  }, [onClick, setDrilldownKey]);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    use: "unstyled"
  }, props, {
    onClick: handleClick,
    children: /*#__PURE__*/_jsxs(UIFlex //@ts-expect-error as isn't exposed in the types but is needed here
    , {
      as: "span",
      justify: "between",
      children: [children, /*#__PURE__*/_jsx(UIIcon, {
        name: "remove"
      })]
    })
  }));
};
export const DropdownDrilldownMenu = ({
  drilldownKey,
  className,
  children
}) => {
  const {
    drilldownKey: currentDrilldownKey
  } = useDropdownState();
  if (drilldownKey === currentDrilldownKey) return /*#__PURE__*/_jsx("section", {
    className: className,
    children: children
  });
  return null;
};